module.exports = __webpack_public_path__ + "static/media/prod17.fbd0585d.jpg";